/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Statistics_Invited_TitleInputs */

const en_admin_statistics_invited_title = /** @type {(inputs: Admin_Statistics_Invited_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`People invited to interviews`)
};

const de_admin_statistics_invited_title = /** @type {(inputs: Admin_Statistics_Invited_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu Gesprächen eingeladene Personen`)
};

/**
* | output |
* | --- |
* | "People invited to interviews" |
*
* @param {Admin_Statistics_Invited_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_statistics_invited_title = /** @type {((inputs?: Admin_Statistics_Invited_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Statistics_Invited_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_statistics_invited_title(inputs)
	return en_admin_statistics_invited_title(inputs)
});